import classNames from 'classnames';

const Card = ({
	className,
	children,
	...props
}: React.HTMLAttributes<HTMLDivElement>) => (
	<div
		className={classNames('bg-white rounded-lg shadow-md', className)}
		{...props}
	>
		{children}
	</div>
);

export default Card;
